import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import Blink from '@components/Blink'
import { FooterSkeletonLinkItem } from '@hooks/useFooter'

type DefaultItemProps = FooterSkeletonLinkItem

const StyledDefaultItem = styled(Blink)`
  ${({
    theme: {
      fonts: { sourceSansPro },
      colors: {
        grey: { grey_100 },
        brandColors: { brand_90 },
      },
    },
  }) => css`
    font-family: ${sourceSansPro};
    font-size: 14px;
    line-height: 1.6;
    color: ${grey_100};
    display: grid;
    align-items: center;
    min-height: 48px;
    text-decoration: none;
    &:hover {
      color: ${brand_90};
    }
  `}
`

const DefaultItem: FunctionComponent<DefaultItemProps> = ({ text, link }) => {
  return <StyledDefaultItem {...link}>{text}</StyledDefaultItem>
}

export default DefaultItem
